import * as React from "react"
import {observer} from "mobx-react"
import {Button} from "@cling/lib.web.mdc"
import {i18n} from "@cling/lib.web.i18n"
import {export_board_state, ui_state} from "../state/index"
import {JobStatus} from "@cling/lib.shared.model"
import {assert_never} from "@cling/lib.shared.utils"
import {running_on_mobile_device} from "@cling/lib.web.utils"
import {classNames} from "@cling/lib.web.utils"
import {runInAction} from "mobx"

export const ExportBoardToast = observer(() => {
    const open_download_url = React.useCallback(() => {
        open(export_board_state.download_url, "_blank")
        export_board_state.close()
    }, [])
    const ref = React.useCallback((elm?: ReactRef<HTMLDivElement>) => {
        runInAction(() => {
            ui_state.toast_shown = !!elm
        })
    }, [])
    const {job_status, download_url} = export_board_state
    if (!job_status) {
        return null
    }
    let text: string
    if (job_status === JobStatus.job_pending || job_status === JobStatus.job_running) {
        text = i18n.exporting_board
    } else if (job_status === JobStatus.job_failed) {
        text = i18n.export_failed
    } else if (job_status === JobStatus.job_succeeded) {
        text = i18n.export_finished
    } else {
        throw assert_never(job_status)
    }
    return (
        <div
            className={classNames("toast", {
                "toast--with-bottom-app-bar": running_on_mobile_device() && ui_state.app_bar_shown,
            })}
            ref={ref}
        >
            <span className="toast__text">{text}</span>
            <progress
                className="toast__progress_bar"
                value={export_board_state.progress_value}
                max={export_board_state.progress_max}
            />
            <div className="toast__action">
                <Button
                    key="cancel" /* ... for `export_board.spec.tsx` */
                    onClick={export_board_state.cancel}
                    data-test-id="ExportBoardToast_cancel"
                >
                    {i18n.cancel}
                </Button>
                <Button
                    key="download" /* ... for `export_board.spec.tsx` */
                    onClick={open_download_url}
                    disabled={!download_url}
                    data-test-id="ExportBoardToast_download"
                >
                    {i18n.download}
                </Button>
            </div>
        </div>
    )
})
